const CustomEvents = {
  ADD_TO_CART: "addToCart",
  ADD_TO_LOCAL_STORAGE: "addToLocalStorage",
  OPEN_TAB_FROM_LINK: "openTabFromLink",
  GET_DATSHEET_FROM_ARTICLE: "getDatasheetFromArticle",
  UPDATE_SHOP_CART: "updateShopCart"
};

export default CustomEvents;
